export interface IWebsocketParams {
  url: string
  query: string
  maxReconnectCount?: number
}
// @ts-ignore
function logs (...args: any[]) {
  // console.log(
  //     '%c[WebsocketClient]:',
  //     'background-color:#358DFF;color:#ffffff;',
  //     ...args
  // )
}

const DEF_RECONNECT_TIMEOUT = 2000
const DEF_HEART_CHECK_TIMEOUT = 5000
const DEF_PING_TIMER_TIMEOUT = 2000
const EVENTNAMES = ['error', 'open', 'message', 'send']
const DEF_RECONNECT_COUNT = 2
export default class WebsocketClient {
  private _params: IWebsocketParams

  private _listeners: Array<Function>
  // @ts-ignore
  private _ws: WebSocket
  // @ts-ignore
  private _heartCheckTimer: NodeJS.Timer
  // @ts-ignore
  private _pingTimer: NodeJS.Timer

  private _isDestroy: Boolean

  private _reconnectCount: number

  private _maxReconnectCount: number // -1 次数不限

  constructor (params: IWebsocketParams) {
    this._params = {
      ...params,
    }
    this._isDestroy = false
    this._listeners = []
    this._reconnectCount = 0
    this._maxReconnectCount = params.maxReconnectCount || DEF_RECONNECT_COUNT

    this.init = this.init.bind(this)
    this.close = this.close.bind(this)
    this.setBinaryType = this.setBinaryType.bind(this)
    this.send = this.send.bind(this)
    this.addEventListener = this.addEventListener.bind(this)
    this.removeEventListener = this.removeEventListener.bind(this)
    this.removeAllEventListener = this.removeAllEventListener.bind(this)

    this._trigger = this._trigger.bind(this)
    this._onError = this._onError.bind(this)
    this._onClose = this._onClose.bind(this)
    this._heartCheck = this._heartCheck.bind(this)
    this._onOpen = this._onOpen.bind(this)
    this._onMessage = this._onMessage.bind(this)
  }

  public init () {
    const { url, query } = this._params
    this._isDestroy = false
    this._ws = new WebSocket(url + query)
    // @ts-ignore
    this._ws.binaryType = 'blob'
    this._ws.addEventListener('open', this._onOpen)
    this._ws.addEventListener('error', this._onError)
    this._ws.addEventListener('close', this._onClose)
    this._ws.addEventListener('message', this._onMessage)
  }
  // @ts-ignore
  public setBinaryType (binaryType) {
    // @ts-ignore
    this._ws.binaryType = binaryType
  }

  public send (msg: string | Blob) {
    if (this._isDestroy) {
      // this._trigger('error', 'ws destroy')
    } else {
      this._ws.send(msg)
      this._trigger('send', msg)
    }
  }

  public close () {
    this._isDestroy = true
    this._ws.close()
    // @ts-ignore
    this._listeners = []
  }

  public addEventListener (eventName: string, handler: Function): () => void {
    if (!EVENTNAMES.includes(eventName)) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => { }
    }
    // @ts-ignore
    const listeners = this._listeners && this._listeners[eventName] || []
    listeners.unshift(handler)
    // @ts-ignore
    this._listeners[eventName] = listeners

    const unbind = () => {
      const idx = listeners.indexOf(handler)
      if (idx > -1) {
        listeners.splice(idx, 1)
      }
    }
    return unbind
  }

  public removeEventListener (eventName: string, handler: Function): void {
    // @ts-ignore
    const listeners = this._listeners && this._listeners[eventName] || []
    const idx = listeners.indexOf(handler)
    if (idx > -1) {
      listeners.splice(idx, 1)
    }
  }

  public removeAllEventListener (eventName: string) {
    // @ts-ignore
    if (this._listeners) this._listeners[eventName] = null
    return this
  }

  private _onError () {
    logs('Web Socket connect failed')
    this._trigger('error', 'Web Socket connect failed')
  }
  // @ts-ignore
  private _onClose (event) {
    this._heartCheckTimer && clearInterval(this._heartCheckTimer)

    if (!this._isDestroy && (this._reconnectCount <= this._maxReconnectCount || this._maxReconnectCount === -1)) {
      this._trigger('error', 'Web Socket connect closed')
      this._reconnect()
      logs(`Web Socket connect closed as clean? ${event.wasClean} Code=${event.code} Reason=${event.reason}`)
    } else {
      logs('The number of Web Socket connections reached the upper limit. Connection aborted')
    }
  }

  private _reconnect () {
    this._reconnectCount += 1
    setTimeout(() => {
      this.init()
    }, DEF_RECONNECT_TIMEOUT)
  }

  private _heartCheck () {
    this._heartCheckTimer = setInterval(() => {
      if (this._isDestroy) {
        clearInterval(this._heartCheckTimer)
      } else {
        this._ws.send('ping')
        this._pingTimer = setTimeout(() => {
          this._ws.close()
        }, DEF_PING_TIMER_TIMEOUT)
      }
      // logs('Web Socket send ping')
    }, DEF_HEART_CHECK_TIMEOUT)
  }

  private _onOpen () {
    logs('Web Socket be connected successfully')
    this._trigger('open', 'Web Socket be connected successfully')
    // this._heartCheck()
  }
  // @ts-ignore
  private _onMessage (event) {
    this._pingTimer && clearTimeout(this._pingTimer)
    if (event.data !== 'pong') {
      this._trigger('message', event)
    }
    if (event.data === 'ping') {
      this._ws.send('pong')
    }
  }

  private _trigger (eventName: string, event: string | Blob) {
    try {
      // @ts-ignore
      const listeners = (this._listeners && this._listeners[eventName] || []) as Array<any>
      // eslint-disable-next-line no-unused-expressions
      listeners && listeners.forEach((listener) => listener(event))
    } catch (err) {
      console.log(err)
    }
  }
}
